import React from 'react';
import {connect} from 'react-redux';
import {loadUser,clearUser} from '../../Redux/actions/user.js';
import {openModal, setModalOptions} from '../../Redux/actions/ui.js';
import {Link} from 'react-router-dom';
import withRouter from '../../withRouter.js';
import { selectIsSiteAdmin } from '../../utils/permissions.js';

let SubmitButton = (props) => {
  return (
    <div onClick={props.handleClick} className="map-horizontal-button"><span><i className="material-icons notranslate">account_circle</i>Sign In</span></div>
  )
}

const formatRoleLabel = (role) => {
  if (!role) return null;
  const roleName = role.toLowerCase();
  if (roleName === 'admin') return 'Company Admin';
  if (roleName === 'editor') return 'Company Editor';
  if (roleName === 'reviewer' || roleName === 'viewer') return 'Reviewer';
  return role;
};

const getUserTypeLabel = (props) => {
  if (props.isSiteAdmin) {
    if (Number(props.siteStaffLevel) === 1) {
      return 'Superuser';
    }
    return 'Site Admin';
  }

  const roleLabels = [...new Set((props.companyRoles || [])
    .map((companyRole) => formatRoleLabel(companyRole && companyRole.role))
    .filter(Boolean))];

  if (roleLabels.length === 0) {
    return 'Viewer';
  }

  return roleLabels.join(', ');
};

let ProfileControls = (props) => {
  const companyList = props.isSiteAdmin
    ? [{ id: 'all-companies', name: 'All Companies', isSiteAdminEntry: true }]
    : (props.companies || []);

  const userTypeLabel = getUserTypeLabel(props);

  return (
    <div className="ProfileControls">
      <div className="WelcomeMessage">Welcome {props.name},</div>

      <div className="UserTypeRow">
        <i className="material-icons notranslate">verified_user</i>
        <div className="UserTypeMessage">User type: <span>{userTypeLabel}</span></div>
      </div>

      {props.isSiteAdmin ? (
        <div className="ProfileSection">
          <div className="ProfileSectionTitle">Site Admin Access</div>
          {Number(props.siteStaffLevel) === 1 ? (
            <div className="CompanyListEntry CompanyListEntryAction">
              <span className="CompanyListActionText" onClick={() => props.openModal('SiteAdminsDirectory')}>Manage site admins</span>
            </div>
          ) : (
            <div className="CompanyListEmpty">Only superusers can manage site admins.</div>
          )}
        </div>
      ) : null}

      <div className="ProfileSection">
        <div className="ProfileSectionTitle">Your Companies</div>
        {companyList.length > 0 ? companyList.map((company, index) => (
          <div key={index} className="CompanyListEntry">
            {company.isSiteAdminEntry ? (
              <span>{company.name}</span>
            ) : (
              <Link to={"/g/" + String(company.id || '').split('/')[0]}>{company.name}</Link>
            )}
          </div>
        )) : <div className="CompanyListEmpty">No companies linked</div>}
      </div>

      <div className="SignOutBtn" onClick={props.handleSignOut}>Sign Out</div>
    </div>
  )
}

class AccountLogin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      profileControlsVisible:false,
      tokenExpiryWatchdogID:null,
      hasReauthorizedWarned:false,
      hasSessionExpiredWarned:false
    };
    this.logout = this.logout.bind(this);
    this.dropdownRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.startTokenExpiryWatchdog = this.startTokenExpiryWatchdog.bind(this);
    this.stopTokenExpiryWatchdog = this.stopTokenExpiryWatchdog.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
    this.startTokenExpiryWatchdog();
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
    this.stopTokenExpiryWatchdog(false);
  }

  handleClickOutside(event) {
    if (this.dropdownRef.current && !this.dropdownRef.current.contains(event.target)) {
      this.setState({profileControlsVisible: false});
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.tokenExp !== this.props.tokenExp) {
      this.setState({hasReauthorizedWarned:false, hasSessionExpiredWarned:false});
      this.startTokenExpiryWatchdog();
    }
  }

  startTokenExpiryWatchdog() {
    if (!this.props.tokenExp) {
      this.stopTokenExpiryWatchdog();
      return;
    }

    if (this.state.tokenExpiryWatchdogID) {
      return;
    }

    let id = setInterval(() => {
      let expiryDate = new Date(this.props.tokenExp * 1000);
      let currentTime = new Date();
      let difference = expiryDate - currentTime;
      if (difference <=0 ) {
        console.log('Token Expired');
        if (!this.state.hasSessionExpiredWarned) {
          this.setState({hasSessionExpiredWarned:true});
          this.props.openModal('ReAuthorize', { sessionExpired: true });
        }
        return;
      }else if (difference <= (10 * (60 * 1000)) && ! this.state.hasReauthorizedWarned) { //10 minutes
        this.setState({hasReauthorizedWarned:true})
        console.log('About to be logged out!');
        this.props.openModal('ReAuthorize');
      }
    }, 10000);

    this.setState({tokenExpiryWatchdogID:id});
  }

  stopTokenExpiryWatchdog(shouldUpdateState = true) {
    if (this.state.tokenExpiryWatchdogID) {
      clearInterval(this.state.tokenExpiryWatchdogID);
      if (shouldUpdateState) {
        this.setState({tokenExpiryWatchdogID:null});
      }
    }
  }

  logout() {
    this.stopTokenExpiryWatchdog();
    this.props.history.push('/');
    this.props.onLogout();
  }

  render() {
    if (this.props.name) {
      const userTypeLabel = getUserTypeLabel(this.props);
      return (
        <div ref={this.dropdownRef} onClick={()=>{this.setState({profileControlsVisible:!this.state.profileControlsVisible})}}>
          <div className="map-horizontal-button"><span><i className="material-icons notranslate">account_circle</i>{`${this.props.name} (${userTypeLabel})`}</span></div>
          {this.state.profileControlsVisible ? <ProfileControls handleSignOut={this.logout} companies={this.props.companies} name={this.props.name} companyRoles={this.props.companyRoles} isSiteAdmin={this.props.isSiteAdmin} siteStaffLevel={this.props.siteStaffLevel} openModal={this.props.openModal} />  : null}
        </div>
      )
    }
    return (
      <div>
        <SubmitButton handleClick={()=>{this.props.openModal('SignIn')}}  />
      </div>
    )
  }
}

let mapStateToProps = state => ({
  name:state.user.name,
  companies:state.user.companies,
  companyRoles: state.user.companyRoles,
  siteStaffLevel: state.user.siteStaffLevel,
  isSiteAdmin: selectIsSiteAdmin(state),
  tokenExp:state.user.exp
})

let mapDispatchToProps = dispatch => ({
  onLogin: (user) => {
    dispatch(loadUser(user));
  },
  onLogout: () => {
    dispatch(clearUser());
  },
  openModal:(modalName, modalOptions = {}) => {
    dispatch(setModalOptions(modalOptions));
    dispatch(openModal(modalName));
  }
})

let AccountLoginContainer = withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountLogin));




export default AccountLoginContainer;
